// ReviewCard.jsx
import React from "react";

const ReviewCard = ({ review }) => {
    const {
        author_name,
        profile_photo_url,
        rating,
        relative_time_description,
        text
    } = review;

    return (
        <div className="review-card" style={cardStyle}>
            <div style={headerStyle}>
                <img
                    src={profile_photo_url || "../public/imgs/avatar.png"}
                    alt={author_name}
                    style={avatarStyle}
                />
                <div style={headerTextStyle}>
                    <h4 style={{ margin: 0 }}>{author_name}</h4>
                    <span style={{ fontSize: "0.8rem", color: "#666" }}>
                        {relative_time_description}
                    </span>
                </div>
            </div>

            <div style={ratingStyle}>
                {"★".repeat(rating)}{"☆".repeat(5 - rating)}
            </div>

            <p style={textStyle}>{text}</p>
        </div>
    );
};

const cardStyle = {
    border: "1px solid #ddd",
    padding: "20px",
    borderRadius: "8px",
    backgroundColor: "#fff",
    height: "100%", // This is key for equal heights
    display: "flex",
    flexDirection: "column",
    width: "100%",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    transition: "transform 0.2s",
    margin: "0" // Remove margins as Swiper handles spacing
};

const headerStyle = {
    display: "flex",
    alignItems: "center",
    marginBottom: "10px",
    gap: "10px",
    flexShrink: 0 // Prevent header from shrinking
};

const headerTextStyle = {
    flex: 1,
    minWidth: 0 // Prevent text overflow
};

const avatarStyle = {
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    flexShrink: 0,
    objectFit: "cover"
};

const ratingStyle = {
    color: "#fbbc04",
    marginBottom: "8px",
    flexShrink: 0,
    fontSize: "1.1rem"
};

const textStyle = {
    fontStyle: "italic",
    color: "#333",
    fontSize: "0.95rem",
    lineHeight: "1.6",
    margin: "0",
    flex: 1, // This makes the text expand to fill available space
    overflow: "hidden",
    display: "-webkit-box",
    WebkitLineClamp: 6, // Optional: limit to 6 lines
    WebkitBoxOrient: "vertical"
};

export default ReviewCard;